import { useSession } from '@/lib/SessionProvider';
import MatchesContent from '@/modules/league/new-components/matches-components/MatchesContent';
import { GameDayInfo, Round } from '@/modules/league/new-components/types';

export default function LeagueMatchesPage({
  params,
  headerContent,
  currentSequenceNumber,
  rounds,
  isAuthorized,
}: {
  params: { slug: string; sessionId: string; matchDateId: string };
  headerContent: GameDayInfo;
  currentSequenceNumber: number;
  rounds: { sequences: Round[] };
  isAuthorized: boolean;
}) {
  const { slug, sessionId, matchDateId } = params;
  const userSession = useSession();

  return (
    headerContent && (
      <MatchesContent
        headerContent={headerContent}
        user={userSession.session?.user}
        params={{ slug, sessionId, matchDateId }}
        currentSequenceNumber={currentSequenceNumber}
        rounds={rounds}
        isAuthorized={isAuthorized}
      />
    )
  );
}
